export default function getImageUrl(fileName: string, pathName: string): string {
  return `${process.env.REACT_APP_URL}/file-stream?filename=${fileName}&path=${pathName}`;
}
